import { secured } from '@/plugins/axios';

const resource = '/proposals/admin';

export default {
    businessProposals: () => secured.get(`${resource}/business-proposals/`),
    staffBusinessProposals: () => secured.get(`${resource}/staff-business-proposals/`),
    serviceProposals: () => secured.get(`${resource}/service-proposals/`),
};
